export const TOGGLE_AUDIO_MUTE = 'events/TOGGLE_AUDIO_MUTE';

/**
 * @return {{type: string}}
 */
export const toggleAudioMute = () => ({ type: TOGGLE_AUDIO_MUTE });
